var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTomtalker = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 424,
    viewBox: "0 0 600 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99999C0 3.58172 3.58172 0 8 0H592C596.418 0 600 3.58172 600 8V424H0V7.99999Z",
    fill: "#F4EFFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.488 341.168H265.34V231.71L274.488 227.452V341.168Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.268 337.545V213.711L247.973 229.69V353.524L256.606 349.504V235.769L274.486 227.452V341.168L282.268 337.545Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.703 229.69V353.524H428.99V239.927H247.814V353.524H237.398V229.69H439.703Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M473.998 337.545V213.711L439.703 229.69V353.524L448.336 349.504V235.769L466.216 227.452V341.168L473.998 337.545Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M466.215 341.168H457.047V231.71L466.215 227.452V341.168Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M439.703 229.69H237.398L271.674 213.711H473.998L439.703 229.69Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.502 166.526H358.047V205.949H368.502V166.526Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M374.401 166.526H368.5V205.949H374.401V166.526Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M368.383 166.526H358.047V176.525H368.383V166.526Z",
    fill: "#040222"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M419.963 99.5396H310.723V169.812H419.963V99.5396Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M413.531 105.222H317.141V164.11H413.531V105.222Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.851 151.859C356.915 149.693 348.691 140.758 348.691 130.311L348.799 122.602C348.806 122.094 349.12 121.64 349.593 121.454L363.483 115.998C364.072 115.767 364.726 115.767 365.315 115.998L379.205 121.454C379.678 121.64 379.992 122.094 379.999 122.602L380.106 130.311C380.106 140.758 371.873 149.451 367.946 151.859C366.932 152.48 365.551 153.142 364.418 153.16C363.288 153.178 361.981 152.48 360.851 151.859Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M348.691 130.311L348.086 130.303V130.311H348.691ZM360.851 151.859L360.559 152.389L360.559 152.389L360.851 151.859ZM367.946 151.859L368.263 152.375L368.263 152.375L367.946 151.859ZM380.106 130.311H380.711L380.711 130.303L380.106 130.311ZM363.483 115.998L363.704 116.561L363.704 116.561L363.483 115.998ZM349.593 121.454L349.372 120.891L349.372 120.891L349.593 121.454ZM379.205 121.454L378.983 122.018L378.983 122.018L379.205 121.454ZM365.315 115.998L365.093 116.561L365.093 116.561L365.315 115.998ZM348.799 122.602L349.404 122.611L348.799 122.602ZM379.999 122.602L379.394 122.611L379.394 122.611L379.999 122.602ZM364.418 153.16L364.408 152.555L364.408 152.555L364.418 153.16ZM348.086 130.311C348.086 135.691 350.201 140.652 352.792 144.527C355.376 148.391 358.482 151.246 360.559 152.389L361.143 151.328C359.284 150.306 356.31 147.61 353.798 143.854C351.293 140.108 349.297 135.378 349.297 130.311H348.086ZM368.263 152.375C370.312 151.118 373.412 148.276 376 144.438C378.593 140.594 380.711 135.692 380.711 130.311H379.501C379.501 135.377 377.503 140.045 374.997 143.761C372.487 147.483 369.507 150.192 367.63 151.343L368.263 152.375ZM363.262 115.434L349.372 120.891L349.814 122.018L363.704 116.561L363.262 115.434ZM379.426 120.891L365.536 115.434L365.093 116.561L378.983 122.018L379.426 120.891ZM348.193 122.594L348.086 130.303L349.297 130.32L349.404 122.611L348.193 122.594ZM379.394 122.611L379.501 130.32L380.711 130.303L380.604 122.594L379.394 122.611ZM360.559 152.389C361.122 152.699 361.76 153.045 362.405 153.309C363.046 153.572 363.743 153.777 364.428 153.766L364.408 152.555C363.962 152.562 363.442 152.426 362.864 152.189C362.291 151.954 361.71 151.64 361.143 151.328L360.559 152.389ZM364.428 153.766C365.736 153.745 367.238 153.003 368.263 152.375L367.63 151.343C366.627 151.958 365.366 152.54 364.408 152.555L364.428 153.766ZM349.372 120.891C348.669 121.167 348.204 121.84 348.193 122.594L349.404 122.611C349.408 122.348 349.57 122.114 349.814 122.018L349.372 120.891ZM363.704 116.561C364.151 116.386 364.647 116.386 365.093 116.561L365.536 115.434C364.805 115.147 363.993 115.147 363.262 115.434L363.704 116.561ZM378.983 122.018C379.228 122.114 379.39 122.348 379.394 122.611L380.604 122.594C380.594 121.84 380.128 121.167 379.426 120.891L378.983 122.018Z",
    fill: "#040222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.629 128.443C360.629 126.36 362.317 124.671 364.4 124.671V124.671C366.483 124.671 368.172 126.36 368.172 128.443V134.456H360.629V128.443Z",
    stroke: "#040222",
    strokeWidth: 1.21058
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 358.59,
    y: 131.806,
    width: 11.62,
    height: 7.99123,
    rx: 1.0436,
    fill: "#4B1BAF",
    stroke: "#040222",
    strokeWidth: 1.21058
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M419.961 169.793L425.901 167.02V96.7675L419.961 99.5396V169.793Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.297 78.4321C350.267 77.8579 352.188 78.9271 353.099 81.2438C354.01 83.5605 353.515 85.8772 353.436 86.293C353.356 86.7088 350.406 85.1247 349.555 82.6298C348.703 80.1745 348.327 79.0261 349.297 78.4321Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364.508 76.3727C366.35 76.2539 366.271 79.2834 366.271 80.511C366.271 81.7387 365.221 84.7484 364.508 84.8276C363.776 84.9068 362.746 81.3426 362.766 79.4418C362.786 77.5409 363.241 76.4519 364.508 76.3727Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M376.724 86.8076C375.892 86.9066 375.813 83.3227 376.724 81.6594C377.635 79.9961 379.219 77.6993 380.209 78.2735C381.199 78.8477 380.862 81.7584 380.209 82.9069C379.536 84.0751 378.051 86.6492 376.724 86.8076Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M316.663 96.7675H425.904L419.963 99.5396H310.723L316.663 96.7675Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M377.133 225.195H306.504L327.295 215.493H397.944L377.133 225.195Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M327.295 215.493V205.949L306.504 220.74V225.195L327.295 215.493Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M327.295 205.949H397.944L377.133 220.74H306.504L327.295 205.949Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M328.957 209.077H386.241L374.182 217.691H316.898L328.957 209.077Z",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M325.137 217.691L337.195 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.312 217.691L345.371 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M341.492 217.691L353.551 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M349.668 217.691L361.727 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M357.844 217.691L369.883 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M366.004 217.691L378.063 209.077",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M323 213.374H380.224",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M377.153 220.74H306.504V225.195H377.153V220.74Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M397.943 215.493V205.949L377.133 220.74V225.195L397.943 215.493Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M188.652 293.785H181.781V366.394H188.652V293.785Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M206.788 296.003C215.183 296.003 224.133 294.914 226.687 287.884C229.242 280.855 223.46 275.945 209.797 275.469C196.115 274.994 172.196 275.469 162.216 275.469C152.237 275.469 145.188 279.39 145.188 285.489C145.188 291.567 148.395 296.003 161.345 296.003C174.295 296.003 198.372 296.003 206.788 296.003Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.959 373.325C161.959 375.542 159.127 377.74 156.375 377.74C153.623 377.74 151.781 376.136 151.781 373.919C151.781 371.701 154.811 369.701 157.563 369.701C160.315 369.681 161.959 371.087 161.959 373.325Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.666 373.523C218.666 375.74 215.834 377.74 213.082 377.74C210.33 377.74 208.488 375.74 208.488 373.523C208.488 371.305 211.32 369.701 214.072 369.701C216.844 369.681 218.666 371.285 218.666 373.523Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.641 369.681H217.221C217.221 366.394 216.706 363.108 212.191 363.108C206.766 363.108 162.61 363.108 158.927 363.108C154.235 363.108 153.641 366.355 153.641 369.681Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 375.166C154.136 374.433 154.849 373.127 155.701 372.77C156.552 372.414 158.552 371.325 159.087 372.315C159.621 373.305 158.393 374.75 157.186 375.344C155.998 375.958 155.364 375.899 154.75 375.166Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M211.481 375.166C210.867 374.433 211.58 373.127 212.431 372.77C213.282 372.414 215.282 371.325 215.817 372.315C216.352 373.305 215.124 374.75 213.916 375.344C212.708 375.958 212.094 375.899 211.481 375.166Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M243.736 335.564L241.578 349.484L252.053 359.167L262.963 350.732L265.002 335.564L253.3 332.238L243.736 335.564Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M241.576 349.484C241.576 349.484 239.002 365.364 238.844 366.612C238.685 367.859 238.765 368.433 240.151 368.592C241.537 368.75 247.932 369.305 255.278 368.909C262.625 368.513 278.188 367.562 278.584 367.562C278.98 367.562 279.059 364.156 278.98 362.434C278.901 360.691 279.059 358.177 274.881 357.543C270.703 356.909 265.416 357.523 263.139 355.207C260.862 352.89 260.268 351.781 260.268 351.781C260.268 351.781 254.605 353.999 250.348 353.999C246.091 353.999 243.794 348.613 241.576 349.484Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M240.348 365.245C240.348 365.245 245.456 365.84 249.278 365.76C252.684 365.701 256.861 365.285 262.307 364.968C267.752 364.651 278.999 364.572 278.999 364.572",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M269.019 357.068C269.019 357.068 265.633 361.167 264.762 360.771C263.89 360.375 266.524 356.751 266.524 356.751C266.524 356.751 263.019 361.305 261.772 360.81C260.504 360.315 264.801 356.256 264.801 356.256C264.801 356.256 260.683 360.038 259.97 359.385C259.257 358.731 263.158 355.207 263.158 355.207",
    stroke: "#040222",
    strokeWidth: 0.606893,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M257.278 338.495L254.961 352.474L265 362.612L277.217 354.415L278.801 339.406L269.396 331.268L257.278 338.495Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.126 343.049L261.785 346.028",
    stroke: "#040222",
    strokeWidth: 0.602738,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M244.404 339.182L247.062 342.162",
    stroke: "#040222",
    strokeWidth: 0.602738,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M267.777 349.83L264.798 352.489",
    stroke: "#040222",
    strokeWidth: 0.602738,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M253.055 345.964L250.075 348.623",
    stroke: "#040222",
    strokeWidth: 0.602738,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M274.336 351.442L271.679 348.483",
    stroke: "#040222",
    strokeWidth: 0.602738,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M265.951 336.634C265.951 336.634 265.159 344.673 277.911 347.682L278.782 339.386L274.743 331.268L265.951 336.634Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M254.964 351.682C254.964 351.682 252.232 369.542 252.053 370.948C251.875 372.354 251.974 372.968 253.499 373.146C255.024 373.324 262.172 373.938 270.349 373.503C278.527 373.067 295.872 371.998 296.308 371.998C296.744 371.998 296.843 368.216 296.744 366.275C296.664 364.335 296.823 361.523 292.17 360.81C287.497 360.097 282.289 360.79 279.755 358.197C277.2 355.603 277.2 354.375 277.2 354.375C277.2 354.375 270.686 357.721 265.934 357.721C261.201 357.761 257.419 350.732 254.964 351.682Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 368.335C253.719 368.335 259.877 368.77 263.659 369.127C267.441 369.483 272.114 369.483 278.173 369.127C284.232 368.77 296.766 368.691 296.766 368.691",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M285.657 360.296C285.657 360.296 282.271 364.889 281.3 364.454C280.33 364.018 283.28 359.959 283.28 359.959C283.28 359.959 278.964 365.048 277.558 364.493C276.152 363.939 280.845 359.088 280.845 359.088C280.845 359.088 276.311 363.642 275.519 362.909C274.726 362.177 279.063 357.543 279.063 357.543",
    stroke: "#040222",
    strokeWidth: 0.606893,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M243.731 335.564L254.067 276.301H200.348L209.931 244.382C209.931 244.382 253.77 244.382 260.463 244.382C267.155 244.382 274.739 244.679 273.828 256.995C272.917 269.311 264.997 335.564 264.997 335.564C264.997 335.564 259.275 337.544 250.8 337.544C244.424 337.544 243.731 335.564 243.731 335.564Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M168.706 223.69C168.706 223.69 163.578 250.005 162.37 262.658C161.796 268.638 160.271 278.182 170.429 280.043C179.418 281.686 185.359 280.855 212.228 280.558C239.098 280.261 266.225 279.667 266.225 279.667L257.275 338.495C257.275 338.495 263.096 339.386 271.155 339.386C279.214 339.386 284.144 338.633 284.144 338.633C284.144 338.633 292.659 283.231 294.599 272.499C296.54 261.747 296.837 247.867 274.739 247.867C252.641 247.867 224.485 247.867 224.485 247.867L227.118 224.7L197.457 220.68L168.706 223.69Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M171.637 257.134C171.637 257.134 169.993 269.074 169.993 272.222C169.993 275.37 169.241 280.934 177.894 280.934",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M209.583 111.461C208.386 120.246 206.089 125.769 205.091 127.433L203.594 131.426L204.592 140.411L215.074 144.404L224.059 140.91L224.558 129.929C224.391 129.43 224.059 127.034 224.059 121.444C226.554 120.944 228.052 115.953 228.551 112.459C228.95 109.664 229.383 102.31 229.549 98.982C230.215 99.3148 231.646 99.2815 232.045 96.4863C232.444 93.6911 230.88 92.9923 230.048 92.9922C230.048 92.3267 230.148 90.0973 230.548 86.5034C231.745 86.5034 234.374 84.5068 235.539 83.5086C237.036 83.0094 238.534 85.5051 244.524 83.0094C250.114 81.0128 250.717 75.855 250.319 73.5257C251.1 71.6729 251.383 69.4037 250.014 68.0351C247.518 65.5394 244.024 66.0385 241.529 67.0368C239.033 68.0351 237.536 71.5291 235.539 70.5308C231.546 68.9335 228.884 70.8636 228.052 72.0282C227.054 73.5257 225.556 76.0214 223.56 75.5222C220.066 75.0231 218.069 76.5205 216.072 79.0162C214.076 81.5119 212.578 89.4982 212.578 92.4931C211.78 92.4931 211.247 92.8259 211.081 92.9922C209.084 95.3881 210.249 97.6509 211.081 98.4828C211.081 99.1484 210.781 102.676 209.583 111.461Z",
    fill: "#FAE900"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M211.081 98.4829L210.582 107.967C210.915 107.634 212.479 105.87 214.076 103.474C213.577 106.968 212.729 117.102 215.573 119.946C218.568 122.941 224.558 123.44 227.054 119.447C229.05 116.253 229.55 105.471 229.55 100.48H215.074C215.241 99.3149 215.673 96.3866 216.073 91.9941C216.472 87.6016 217.237 86.8363 217.57 87.0027C219.067 87.3354 222.561 87.6017 224.558 86.0044C227.054 84.0078 226.055 86.0044 228.551 86.5035C231.047 87.0027 231.546 86.0044 236.038 83.5087C240.032 84.0078 243.026 84.0078 246.021 82.5104C249.016 81.0129 250.514 78.018 250.514 74.0248C252.51 68.5342 250.514 66.5378 245.522 66.0386C240.531 65.5395 239.532 70.0318 237.536 70.5309C235.539 71.0301 236.538 70.0318 232.544 70.0318C228.551 70.0318 227.054 74.5241 226.055 75.0232C225.057 75.5224 223.061 75.0232 220.066 76.0215C217.071 77.0198 215.78 80.5995 215.074 82.0112C213.577 85.006 213.078 89.831 212.579 92.9923L213.577 92.9924V97.4847C213.577 99.082 211.58 98.6493 211.081 98.4829Z",
    fill: "#ED7976"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M248.018 76.5205C248.694 76.2951 249.676 75.0516 250.319 73.5257M250.319 73.5257C251.1 71.6729 251.383 69.4037 250.014 68.0351C247.518 65.5394 244.024 66.0385 241.529 67.0368C239.033 68.0351 237.536 71.5291 235.539 70.5308C231.546 68.9335 228.884 70.8635 228.052 72.0282C227.054 73.5257 225.556 76.0214 223.56 75.5222C220.066 75.0231 218.069 76.5205 216.072 79.0162C214.076 81.5119 212.578 89.4982 212.578 92.4931C211.78 92.4931 211.247 92.8259 211.081 92.9922C209.084 95.3881 210.249 97.6509 211.081 98.4828C211.081 99.1484 210.781 102.676 209.583 111.461C208.386 120.246 206.089 125.769 205.091 127.433L203.594 131.426L204.592 140.411L215.074 144.404L224.059 140.91L224.558 129.929C224.391 129.43 224.059 127.533 224.059 121.943C226.554 121.444 228.052 115.953 228.551 112.459C228.95 109.664 229.383 102.31 229.549 98.982M250.319 73.5257C250.717 75.855 250.114 81.0128 244.524 83.0094C238.534 85.5051 237.036 83.0094 235.539 83.5086C234.374 84.5068 231.745 87.0026 230.548 87.0026C230.148 90.5964 230.048 92.3267 230.048 92.9922M230.048 92.9922C230.88 92.9923 232.444 93.6911 232.045 96.4863C231.646 99.2815 230.215 99.3148 229.549 98.982M230.048 92.9922L229.549 98.982",
    stroke: "#040222",
    strokeWidth: 1.21058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.567 83.0095C221.563 81.3457 226.455 77.8184 230.049 77.0198C232.544 76.5206 232.544 78.018 232.045 79.5155C231.546 81.0129 234.042 79.0163 237.037 77.0198C240.032 75.0232 246.021 72.5275 250.014 72.0283M217.57 87.0026C218.901 87.169 222.162 87.2023 224.558 86.0044C227.553 84.5069 226.555 86.0044 229.05 86.5035C231.047 86.9028 233.21 85.6716 234.042 85.0061M213.577 97.9838V92.9924M216.572 88.5001L215.074 100.48H229.55M224.059 92.9924L225.057 96.4864L222.561 96.9855M210.582 107.967C211.248 107.468 212.579 106.17 212.579 104.972M214.076 103.974C213.244 108.133 212.479 117.251 216.073 120.445C220.565 124.438 225.556 120.944 226.055 119.946",
    stroke: "#040222",
    strokeWidth: 0.605288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M225.056 104.972C226.054 104.972 227.052 106.968 226.054 108.466C225.701 108.996 225.097 109.588 224.354 110.067C223.389 110.687 222.19 111.114 220.998 110.961C220.514 110.899 220.031 110.742 219.565 110.462C217.07 108.965 218.567 104.972 220.064 104.972C221.395 104.972 220.952 106.081 221.1 106.968C221.151 107.275 221.272 107.555 221.562 107.753C221.692 107.842 221.855 107.915 222.061 107.967C222.531 108.084 222.89 107.98 223.178 107.753C223.572 107.442 223.832 106.899 224.058 106.375C224.368 105.656 224.614 104.972 225.056 104.972Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M226.054 108.466C227.052 106.968 226.054 104.972 225.056 104.972C224.614 104.972 224.368 105.656 224.058 106.375M226.054 108.466C225.056 109.963 222.061 111.96 219.565 110.462C217.07 108.965 218.567 104.972 220.064 104.972C221.395 104.972 220.952 106.081 221.1 106.968M226.054 108.466L224.058 106.375M221.1 106.968L218.567 108.965M221.1 106.968C221.151 107.275 221.272 107.555 221.562 107.753M221.562 107.753C221.692 107.842 221.855 107.915 222.061 107.967C222.531 108.084 222.89 107.98 223.178 107.753M221.562 107.753L220.998 110.961M223.178 107.753L224.354 110.067M223.178 107.753C223.572 107.442 223.832 106.899 224.058 106.375",
    stroke: "#040222",
    strokeWidth: 0.605288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M217.573 92.4934C217.906 91.6615 218.971 89.9977 220.568 89.9977C222.349 89.9977 222.938 91.5865 222.691 92.9925C222.815 92.6598 223.363 91.9943 224.561 91.9943C225.399 91.9943 225.634 92.3199 225.643 92.6295C226.211 90.4981 227.632 90.5223 229.053 90.996C230.551 91.4951 231.05 95.4883 228.055 95.9874C225.659 96.3867 225.393 94.1572 225.559 92.9925C225.585 92.8651 225.613 92.7442 225.643 92.6295C225.634 92.3199 225.399 91.9943 224.561 91.9943C223.363 91.9943 222.815 92.6598 222.691 92.9925C222.661 93.1626 222.618 93.3301 222.564 93.4917C222.065 94.9891 221.566 95.9874 219.57 95.9874C217.573 95.9874 217.074 93.9908 217.573 92.4934Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M214.578 92.9925C215.077 92.8262 216.375 92.4934 217.573 92.4934M217.573 92.4934C217.906 91.6615 218.971 89.9977 220.568 89.9977C222.349 89.9977 222.938 91.5865 222.691 92.9925M217.573 92.4934C217.074 93.9908 217.573 95.9874 219.57 95.9874C221.566 95.9874 222.065 94.9891 222.564 93.4917C222.618 93.3301 222.661 93.1626 222.691 92.9925M222.691 92.9925C222.815 92.6598 223.363 91.9943 224.561 91.9943C225.759 91.9943 225.726 92.6598 225.559 92.9925M225.559 92.9925C225.393 94.1572 225.659 96.3867 228.055 95.9874C231.05 95.4883 230.551 91.4951 229.053 90.996C227.556 90.4968 226.058 90.4968 225.559 92.9925ZM226.558 93.4917C226.791 93.0245 227.336 92.3769 228.055 92.4469M229.053 92.9925C228.696 92.6356 228.36 92.4766 228.055 92.4469M219.07 92.9925C219.367 92.4533 219.949 91.7324 220.568 91.7268M221.566 92.4934C221.25 91.9314 220.904 91.7237 220.568 91.7268M220.568 91.7268V92.9925M228.055 92.4469V93.4917",
    stroke: "#040222",
    strokeWidth: 0.605288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M224.062 126.435C218.072 129.23 215.244 122.442 214.578 118.948C214.911 119.447 216.175 121.144 218.571 121.943C220.967 122.741 223.23 121.943 224.062 121.443V126.435Z",
    fill: "#040222"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M223.064 98.4828C222.461 98.1815 222.564 97.4845 222.564 96.9854H223.563C223.729 97.6509 223.862 98.8821 223.064 98.4828Z",
    fill: "#040222"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M296.627 179.515C296.627 179.515 313.834 179.515 317.418 179.515C321.021 179.515 332.466 179.515 336.07 179.515C339.674 179.515 344.188 180.247 347.396 183.772C350.584 187.296 350.722 190.762 350.802 192.167C350.861 193.573 350.188 194.326 349.376 194.326C348.564 194.326 347.812 193.296 347.752 192.544C347.713 191.771 346.426 187.871 343.792 186.207C341.159 184.544 340.01 184.128 337.793 184.287C337.793 184.287 335.575 181.178 327.932 181.356C327.932 181.356 334.921 180.861 337.793 184.287C339.119 185.851 335.971 186.92 335.971 186.92C335.971 186.92 335.238 184.168 327.338 183.911C327.338 183.911 334.149 184.109 335.971 186.92C337.793 189.732 334.565 189.95 334.565 189.95C334.565 189.95 334.426 186.881 323.714 187.356C323.714 187.356 333.001 186.544 334.565 189.95C335.595 192.167 333.377 193.811 331.971 194.722C330.565 195.633 328.486 195.514 326.051 195.514C323.635 195.514 321.041 195.395 319.417 194.544C319.417 194.544 321.635 193.653 321.635 191.771L327.595 191.296L321.635 191.771C321.635 191.771 321.556 193.771 319.417 194.544C317.299 195.316 311.458 195.138 300.943 195.791C290.429 196.425 296.627 179.515 296.627 179.515Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M160.692 125.122C158.395 125.122 156.811 125.122 156.811 125.122H142.554C142.554 125.122 139.01 135.359 137.862 142.804C136.713 150.249 137.485 155.615 145.406 155.615C151.108 155.615 153.108 149.418 153.92 145.061C159.662 145.061 162.335 142.032 162.989 137.062C163.682 132.092 165.107 125.122 160.692 125.122ZM160.296 129.419C160.177 130.31 159.068 137.517 158.732 139.695C158.395 141.873 154.395 142.012 154.395 142.012C154.435 141.715 154.474 141.458 154.494 141.26C154.791 139.517 155.94 131.201 156.494 127.221C156.494 127.221 157.543 127.28 158.553 127.34C159.563 127.399 160.395 128.508 160.296 129.419Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M150.436 108.351C148.337 108.965 146.555 111.777 146.555 115.202C146.555 118.628 149.228 118.806 151.366 118.806C153.485 118.806 155.98 117.143 157.287 115.024C158.574 112.905 158.495 108.747 158.495 107.896C158.495 107.064 159.881 105.222 161.722 104.747C163.564 104.292 166.157 101.975 166.157 99.302C166.157 96.6289 163.762 94.3123 161.168 94.3123C158.574 94.3123 155.049 96.7279 154.891 99.1238C154.614 103.104 155.881 104.213 155.524 105.5C155.168 106.787 152.653 107.698 150.436 108.351Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 79.7587C170.946 79.7587 171.48 83.8574 171.48 85.0059C171.48 86.1543 169.738 89.4808 166.728 89.4808C163.718 89.4808 162.312 87.58 162.312 85.5999C162.312 83.6198 163.184 79.7587 167.5 79.7587Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M171.899 135.617C171.543 136.904 168.85 147.774 168.85 147.774L163.487 151.641L158.851 147.853L160.038 142.963C160.009 142.964 158.824 143.022 158.296 143.042C156.752 143.081 156.158 142.289 156.158 141.002C156.158 139.775 157.702 139.22 157.702 139.22C156.752 139.28 156.395 138.626 156.356 137.834C156.316 136.765 158.138 136.151 158.138 136.151C157.049 136.349 156.257 135.914 156.158 135.082C156.059 134.25 157.346 133.28 157.9 132.943C158.455 132.607 159.544 132.211 162.454 131.854C165.365 131.498 169.008 132.013 170.85 132.151C172.691 132.29 172.256 134.329 171.899 135.617Z",
    fill: "#FAE900"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M168.85 147.774C168.85 147.774 171.543 136.904 171.899 135.617C172.256 134.329 172.691 132.29 170.85 132.151C169.008 132.013 165.365 131.498 162.454 131.854C159.544 132.211 158.455 132.607 157.9 132.943C157.346 133.28 156.059 134.25 156.158 135.082C156.257 135.914 157.049 136.349 158.138 136.151C158.138 136.151 156.316 136.765 156.356 137.834C156.395 138.626 156.752 139.28 157.702 139.22C157.702 139.22 156.158 139.775 156.158 141.002C156.158 142.289 156.752 143.081 158.296 143.042C158.831 143.022 160.039 142.963 160.039 142.963L161.524 136.844L158.851 147.853L163.487 151.641L168.85 147.774Z",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M207.601 130.092C201.878 130.092 197.364 132.29 192.671 136.527C187.978 140.765 160.891 164.07 160.891 164.07L165.999 159.674L168.851 147.774C168.851 147.774 163.01 148.388 161.762 148.388C160.515 148.388 158.851 147.853 158.851 147.853C158.851 147.853 151.406 175.04 150.258 178.842C149.109 182.643 153.941 186.9 158.02 184.505C162.099 182.109 185.048 164.506 185.048 164.506L191.325 145.121L185.048 164.506L168.692 223.69C168.692 223.69 185.741 226.165 198.314 226.165C210.888 226.165 227.105 224.7 227.105 224.7L234.411 173.832L220.372 155.596C220.372 155.596 246.093 189.178 249.321 193.118C252.529 197.058 255.756 198.227 263.36 197.949C270.963 197.652 300.922 195.751 300.922 195.751C300.922 195.751 302.585 190.267 302.169 185.712C301.753 181.158 297.932 179.495 296.605 179.495C295.279 179.495 270.627 179.752 268.647 179.752C266.647 179.752 265.241 179.079 263.578 176.525C261.914 173.951 240.173 141.181 236.53 137.28C232.886 133.379 228.986 130.092 221.679 130.092C214.373 130.092 207.601 130.092 207.601 130.092Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M207.601 130.092C201.878 130.092 197.364 132.29 192.671 136.527C187.978 140.765 160.891 164.07 160.891 164.07L165.999 159.674L168.851 147.774C168.851 147.774 163.01 148.388 161.762 148.388C160.515 148.388 158.851 147.853 158.851 147.853C158.851 147.853 151.406 175.04 150.258 178.842C149.109 182.643 153.941 186.9 158.02 184.505C162.099 182.109 185.048 164.506 185.048 164.506L191.325 145.121L185.048 164.506L168.692 223.69C168.692 223.69 185.741 226.165 198.314 226.165C210.888 226.165 227.105 224.7 227.105 224.7L234.411 173.832L220.372 155.596C220.372 155.596 246.093 189.178 249.321 193.118C252.529 197.058 255.756 198.227 263.36 197.949C270.963 197.652 300.922 195.751 300.922 195.751C300.922 195.751 302.585 190.267 302.169 185.712C301.753 181.158 297.932 179.495 296.605 179.495C295.279 179.495 270.627 179.752 268.647 179.752C266.647 179.752 265.241 179.079 263.578 176.525C261.914 173.951 240.173 141.181 236.53 137.28C232.886 133.379 228.986 130.092 221.679 130.092C214.373 130.092 207.601 130.092 207.601 130.092Z",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M232.526 187.138C232.526 187.138 219.992 160.169 219.497 158.467C219.002 156.764 219.299 154.15 220.408 155.595C221.517 157.041 234.447 173.832 234.447 173.832L232.526 187.138Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M162.829 228.581C168.176 228.581 176.274 227.314 177.898 219.156C179.521 210.998 176.987 205.275 168.275 204.741C159.562 204.206 144.335 204.741 137.979 204.741C131.623 204.741 126 209.295 126 216.364C126 223.433 129.168 228.581 137.425 228.581C145.682 228.581 157.483 228.581 162.829 228.581Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M144.1 225.472C144.1 225.472 137.051 267.113 136.417 270.796C135.783 274.479 132.734 287.607 146.674 287.607C153.406 287.607 159.802 287.607 159.802 287.607C159.802 287.607 159.802 285.231 159.802 284.399C159.802 283.567 158.416 282.201 158.416 282.201C158.416 282.201 151.05 282.162 148.396 282.201C144.179 282.28 140.377 280.518 142.238 271.331C143.545 264.796 150.693 225.492 150.693 225.492H144.1V225.472Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.21379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTomtalker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tomtalker.2d569cc55a85cacc30cb26b728611687.svg";